import React from "react";
import Box from "@mui/material/Box";
import workersPng from "src/assets/images/workers.png"; // ✅ place your PNG in this folder

const UserManagementIcon = ({ size = 55, ...props }) => (
  <Box
    component="img"
    src={workersPng}
    alt="User Management Icon"
    sx={{
      width: size,
      height: size,
      display: "inline-block"
    }}
    {...props}
  />
);

export default UserManagementIcon;
